export function isPosthogEnabled(): boolean {
  return process.env.NEXT_PUBLIC_POSTHOG_ENABLED === 'true';
}
